import { render, staticRenderFns } from "./ProgramMedia.vue?vue&type=template&id=5d458501&scoped=true&"
import script from "./ProgramMedia.vue?vue&type=script&lang=ts&"
export * from "./ProgramMedia.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramMedia.vue?vue&type=style&index=0&id=5d458501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d458501",
  null
  
)

export default component.exports